module["exports"] = [
  "gmail.com",
  "yahoo.co.kr",
  "hanmail.net",
  "naver.com"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ko/internet/free_email.js
 ** module id = 739
 ** module chunks = 0
 **/